import { useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import '../../css/Account/Account.css'
import logo from '../../Assets/logo.png'

export default function ResetPassword() {
    const API = process.env.REACT_APP_BACKEND_URL;
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    const res = await axios.post(`${API}/reset-password/${token}`, { newPassword: password });
    setMessage(res.data.message);
  };

  return (
    <form onSubmit={handleReset} className="password-reset">
        <img src={logo} alt="dentalcoopplus" />
        <h2>Jelszó Visszaállítás</h2>
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Új Jelszó" />
      <button type="submit">Mentés</button>
      <p>{message}</p>
    </form>
  );
}